import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { validators, formats, dates } from "investira.sdk";
import { IconButton, Tooltip, Stack, Icon } from "investira.react.components";
import { BulkContextActions, DataTable } from "../";
import { MutedCopy } from "../../molecules";
import { displays } from "investira.react.lib";
import { CARTEIRA_TIPO } from "../../../enums";
import usePerfil from "../../../hooks/usePerfil";

const CarteirasDataGrid = (props) => {
  const {
    state,
    output_id,
    onFavClick,
    onEditClick,
    onBulkDeleteClick,
    onDeleteClick,
    renderDetailPanel,
    ...restProps
  } = props;

  const { usuarioPrioridade } = usePerfil();

  const columns = useMemo(
    () => [
      {
        accessorKey: "carteira",
        header: "Carteira",
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          sx: {
            width: "100% !important",
          },
        },
        Cell: ({ cell, row }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return (
            <MutedCopy title="Copiar ID" value={row.original.carteira_id}>
              {cell.getValue()}
            </MutedCopy>
          );
        },
      },
      {
        accessorKey: "carteira_seuid",
        header: "ISIN/Código",
        enableColumnActions: false,
        enableSorting: false,
      },
      {
        accessorKey: "data_posicao",
        header: "Última Posição",
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return formats.formatDate(dates.toDate(cell.getValue()));
        },
      },
      // {
      //   accessorKey: "ifeed_cnpj",
      //   header: "CNPJ",
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   Cell: ({ cell }) => {
      //     if (validators.isNull(cell.getValue())) {
      //       return;
      //     }
      //     return displays.cnpj(cell.getValue());
      //   },
      // },
      {
        accessorKey: "carteira_tipo_id",
        header: "Tipo",
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return CARTEIRA_TIPO[cell.getValue()]?.label;
        },
      },
    ],
    []
  );

  const xProps = {
    columns,
    state,
    enableRowSelection: usuarioPrioridade <= 6,
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "",
      },
    },
    renderTopToolbarCustomActions: ({ table }) => {
      if (usuarioPrioridade > 6) {
        return null;
      }

      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;

      return (
        <BulkContextActions
          onDeleteClick={() => {
            onBulkDeleteClick(selectedRows);
          }}
          disabled={
            state.isLoading || state.showProgressBars || !isSomeRowSelected
          }
        />
      );
    },
    renderRowActions: ({ row }) => {
      const { carteira_id, favorito } = row.original;
      return (
        <Stack direction="row" spacing={2}>
          <Tooltip title="Visualizar Posições">
            <IconButton
              color="primary"
              onClick={() => onEditClick(row.original)}
            >
              <Icon iconName="eye" size={21} />
            </IconButton>
          </Tooltip>

          {usuarioPrioridade <= 6 && (
            <Tooltip title="Favoritar">
              <IconButton
                color="primary"
                onClick={() => {
                  onFavClick &&
                    onFavClick({
                      carteira_id,
                      favorito: Boolean(favorito) ? 0 : 1,
                    });
                }}
              >
                <Icon
                  iconName={Boolean(favorito) ? "star5_filled" : "star5"}
                  size={21}
                />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      );
    },
    ...restProps,
  };

  return <DataTable {...xProps} />;
};

CarteirasDataGrid.propTypes = {
  data: PropTypes.array.isRequired,
  state: PropTypes.object,
  initialState: PropTypes.object,
};

export default CarteirasDataGrid;
